<div>
  <h1 class="page-header-title">{{ 'AUDIT_TRAIL.TITLE' | translate }}</h1>
  <mat-divider></mat-divider>
  <ag-grid-angular
    domLayout="autoHeight"
    [pagination]="true"
    [theme]="theme"
    [rowData]="auditTrail()"
    [columnDefs]="columnDefs()"
    [tooltipShowDelay]="tooltipShowDelay"
    [tooltipHideDelay]="tooltipHideDelay"
    [defaultColDef]="defaultColDef"
    (firstDataRendered)="onRowDataUpdated()"
    (gridReady)="onGridReady($event)"
    style="padding-top: 20px"
  ></ag-grid-angular>
</div>
